(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-overview/assets/javascripts/overview-modal.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-overview/assets/javascripts/overview-modal.js');
"use strict";

const Paper = svs.ui.ReactPaper;
const {
  CouponOverview
} = svs.components.tipsen.couponOverview;
const {
  TipsenModal,
  StickyBottom,
  StickyButtonClose
} = svs.components.tipsen.tipsenModal;
const {
  useBranding
} = svs.components.tipsen.hooks;
const OverviewStickyBottom = _ref => {
  let {
    toggleOverview
  } = _ref;
  const [productBranding] = useBranding();
  return React.createElement(StickyBottom, {
    className: "".concat(productBranding ? "sticky-bottom-".concat(productBranding) : '')
  }, React.createElement(StickyButtonClose, {
    onClick: toggleOverview
  }));
};
const OverviewModal = _ref2 => {
  let {
    isOverviewShowing,
    toggleOverview
  } = _ref2;
  return React.createElement(TipsenModal, {
    Bottom: () => React.createElement(OverviewStickyBottom, {
      toggleOverview: toggleOverview
    }),
    className: "tipsen-overview-row",
    isOpen: isOverviewShowing
  }, React.createElement(Paper, {
    branding: "sport",
    className: "overview-row-modal"
  }, React.createElement(CouponOverview, null)));
};
OverviewModal.defaultProps = {
  toggleOverview: () => {}
};
setGlobal('svs.components.tipsen.couponOverview.OverviewModal', OverviewModal);

 })(window);